import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/db/client";
import { PIPELINES_KEY } from "@/hooks/usePipelines";

/**
 * Keeps pipelines fresh app-wide (#9304), like useGlobalTeamsSync does for
 * teams. usePipelines is staleTime: Infinity and read by several components
 * at once — the backlog, the ticket page, the activity feed, the new-ticket
 * form — so one subscription here replaces one per reader, each of which
 * would otherwise refetch the same list on every change.
 *
 * All three tables notify (0058): the pipeline itself, its steps, and the
 * departments that chose it.
 */
export const useGlobalPipelinesSync = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const invalidate = () => queryClient.invalidateQueries({ queryKey: PIPELINES_KEY });

    const channel = supabase
      .channel("global-pipelines-sync")
      .on("postgres_changes", { event: "*", schema: "public", table: "pipelines" }, invalidate)
      .on("postgres_changes", { event: "*", schema: "public", table: "pipeline_steps" }, invalidate)
      .on("postgres_changes", { event: "*", schema: "public", table: "pipeline_subsheets" }, invalidate)
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient]);
};
